export type ProfileColorPair = {
  background: string
  text: string
}

export const PROFILE_COLOR_PAIRS: ProfileColorPair[] = [
  { background: '#FADCDC', text: '#8C3A3A' },
  { background: '#FAE6D4', text: '#8C5A2E' },
  { background: '#F5EBC4', text: '#7A611F' },
  { background: '#D8F0DF', text: '#2E6B44' },
  { background: '#D4EEEC', text: '#276B66' },
  { background: '#DAE8F7', text: '#2F5A88' },
  { background: '#E6DEF5', text: '#5B448C' },
  { background: '#F5DCEE', text: '#863974' }
]

export const getProfileColorIndex = (initials: string): number => {
  let hash = 0
  for (const char of initials) {
    hash = hash * 31 + char.charCodeAt(0)
  }
  return hash % PROFILE_COLOR_PAIRS.length
}
